<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="creatorName" placeholder="用户"></el-input>
                        <el-input v-model="demandName" placeholder="需求名称"></el-input>
                        <el-select v-model="typeValue" placeholder="需求类型">
                            <el-option
                                label="全部"
                                value="">
                            </el-option>
                            <el-option label="设计需求" value="DESIGN"></el-option>
                            <el-option label="建模需求" value="MODEL"></el-option>
                        </el-select>
                        <el-input
                            v-model="monyeInput"
                            placeholder="预算金额"
                        ></el-input>
                        <el-select v-model="statusValue" placeholder="状态">
                            <el-option
                                label="待审核"
                                value="AUDIT">
                            </el-option>
                            <el-option
                                label="审核通过"
                                value="PASS">
                            </el-option>
                            <el-option
                                label="审核拒绝"
                                value="REJECT">
                            </el-option>
                            <el-option
                                label="支付中"
                                value="PAYING">
                            </el-option>
                            <el-option
                                label="设计中"
                                value="DESIGNING">
                            </el-option>
                            <el-option
                                label="已验收"
                                value="FINISHED">
                            </el-option>
                            <el-option
                                label="已过期"
                                value="END">
                            </el-option>
                        </el-select>
                        <el-date-picker
                            v-model="createDateValue"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="报价截止日期"
                        >
                        </el-date-picker>
                        <el-button class="searchBtn" @click="search(1)">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%"
                            class="tableContent"
                        >
                            <el-table-column
                                prop="creatorName"
                                label="用户"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="需求名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="type"
                                label="需求类型"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip
                                width="200"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="money"
                                label="预算金额"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="expectedDeliveryTime"
                                label="期望交期"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="deadline"
                                label="报价截止日期"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="statusCn"
                                align="center"
                                header-align="center"
                                label="状态"
                            >
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center"
                                width="230"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="small"
                                        v-if="scope.row.statusCn === '待审核'"
                                        @click="toDialog(0,scope.row)"
                                    >审核
                                    </el-button
                                    >
                                    <el-button
                                        type="text"
                                        size="small"
                                        v-if="scope.row.statusCn  != '待审核'"
                                        @click="toDialog(1,scope.row)"
                                    >查看
                                    </el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handlePageChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total"
                            class="pagination"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--审核查看弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="800px"
        >
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <h3>需求信息</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">用户:</div>
                                <div class="name" v-text="demand.creatorName">某某设计需求</div>
                            </div>
                            <div class="one-row">
                                <div class="label">需求名称:</div>
                                <div class="name" v-text="demand.demandName">某某设计需求</div>
                            </div>
                            <div class="two-row">
                                <div class="label">报价截止日期:</div>
                                <div class="name" v-text="demand.deadline">2021-10-11</div>
                            </div>
                            <div class="two-row">
                                <div class="label">需求类型:</div>
                                <div class="name" v-text="demand.demandTypeCn">设计需求--工艺设计</div>
                            </div>
                            <div class="two-row">
                                <div class="label">期望交期:</div>
                                <div class="name" v-text="demand.expectedDeliveryTime">2021-10-21</div>
                            </div>
                            <div class="two-row">
                                <div class="label">预算金额:</div>
                                <div class="name" v-text="demand.prePrice">100 - 1000 元</div>
                            </div>
                            <div class="two-row">
                                <div class="label">需求分类:</div>
                                <div class="name" v-text="demand.demandClassName"></div>
                            </div>
                            <div class="two-row" v-if="demand.demandType == 'MODEL'">
                                <div class="label">规格尺寸:</div>
                                <div class="name">{{demand.specificationsStart}} - {{demand.specificationsEnd}} cm</div>
                            </div>
                            <div class="two-row">
                                <div class="label">SEO关键词:</div>
                                <div class="name" v-text="demand.metaKeywords"></div>
                            </div>
                            <div class="two-row">
                                <div class="label">SEO描述:</div>
                                <div class="name" v-text="demand.metaDescription"></div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem">
                        <h3>需求详情</h3>
                        <div class="itemContent">
                            <div class="two-row">
                                <div class="label">交付文件类型:</div>
                                <div class="name" v-text="demand.fileType">BMP、JPG</div>
                            </div>
                            <div class="two-row">
                                <div class="label">交易方式:</div>
                                <div class="name">线上交易</div>
                            </div>
                            <div class="two-row " style="width:100%">
                                <div class="label">需求描述:</div>
                                <div style="margin-top:14px">
                                    <div class="name" v-text="demand.demandDes" style="marginTop:-12px">这里是需求描述</div>
                                    <br>
                                    <div class="name nameimg vHtmlMess" v-html="demand.remark" style="marginTop:-12px">这里是需求详情
                                    </div>
                                </div>

                            </div>
                            <div class="two-row" style="width:100%">
                                <div class="label">上传文件:</div>
                                <div class="name" v-show="title == '审核详情'">
                                    <a v-for="(items, index) in demand.demandAttachments" :key="index"
                                       :href="items.fileUrl" :download="items.fileName" style="display:block">{{items.fileName}}</a>
                                </div>
                                <div class="name" v-show="title == '查看详情'">
                                    <a v-for="(items, index) in demand.demandAttachments" :key="index"
                                       :href="items.fileUrl" :download="items.fileName" style="display:block">{{items.fileName}}</a>
                                </div>
                            </div>
                            <!-- <div class="two-row">
                              <div class="label">备注:</div>
                              <div class="name" v-text="demand.remark">这里是备注</div>
                            </div> -->

                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 1">
                    <h3>审核结果</h3>
                    <div class="auditContent">
                        <el-tag type="success" effect="dark" v-if="demand.status == 'PASS'">审核已通过</el-tag>
                        <el-tag type="danger" effect="dark" v-if="demand.status == 'REJECT'">审核已驳回</el-tag>
                        <div class="cause" v-if="demand.status == 'REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" v-text="demand.reason">
                                撒旦咯技术的案件卡刷点卡大家开始的阿萨的金卡多久啊口水都快就卡死的卡就卡死的卡就卡死的卡
                            </div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 0">
                    <h3>审核</h3>
                    <div class="auditContent">
                        <el-radio-group v-model="auditForm.status">
                            <el-radio label="PASS">通过</el-radio>
                            <el-radio label="REJECT">驳回</el-radio>
                        </el-radio-group>
                        <div class="cause" v-if="auditForm.status === 'REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" style="width: 100%">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 5 }"
                                    placeholder="请输入驳回原因"
                                    v-model="auditForm.reason"
                                >
                                </el-input>
                            </div>
                        </div>
                        <div class="auditEnter">
                            <el-button type="primary" @click="auditSubmit(demand.uuid)">确定</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {auditDemand, demandListByPage, getUserInfo} from "../../../utils/interface";
    import {mapState, mapMutations} from "vuex";

    export default {
        components: {},
        data() {
            return {
                form: {
                    isAdmin:'isAdmin'
                },
                auditForm: {},
                createDateValue: null,
                typeValue: null,
                statusValue: "",
                monyeInput: "",
                demandName: "",
                creatorName: "",
                tableData: [],
                current: 0,
                pageSize: 10,
                total: 0,
                dialogVisible: false,
                title: "",
                auditRadio: "",
                textarea: "",
                currentAudit: "",
                demand: {},
            };
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120;
                return {minHeight: height + "px"};
            },
        },
        created() {
            this.search();
        },
        // updated(){
        //     let obj=document.getElementsByClassName("nameimg")
        // },
        methods: {
            // userInfo(row, column){
            //     getUserInfo(row.creator).then((res)=>{
            //         if(res){
            //             return res.name;
            //         }
            //     });
            // },
            resetData() {
                this.createDateValue = null;
                this.typeValue = null;
                this.statusValue = "";
                this.monyeInput = "";
                this.demandName= "",
                this.creatorName= "",
                this.current = 1;
                this.search();
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
            },
            handlePageChange(val) {
                this.current = val;
                this.search();
            },
            search(val) {
                this.form.creatorName = this.creatorName;
                this.form.demandName = this.demandName;
                this.form.createDateValue = this.createDateValue;
                this.form.demandType = this.typeValue;
                this.form.status = this.statusValue;
                this.form.prePrice = this.monyeInput;
                if (this.createDateValue != null) {
                    this.form.deadline = this.createDateValue;
                }
                if(val==null){
                    this.form.current =this.current;
                }else {
                    this.current = val;
                    this.form.current =val;
                }
                this.form.statusNotEq = "DRAFT";
                this.form.pageSize = this.pageSize;
                demandListByPage(this.form).then((res) => {
                    this.tableData = [];
                    console.log(res);
                    if (res != null && res.list != null && res.list.length > 0) {
                        this.total = res.total;
                        res.list.forEach((item, index) => {
                            let demand = {};
                            demand.demandDetail = item;

                            demand.uuid = item.uuid;
                            demand.demandNo = item.demandNo;
                            demand.name = item.demandName;
                            demand.type = item.demandTypeCn;
                            demand.creator = item.creator;
                            demand.creatorName = item.creatorName;
                            // if(item.priceType == 'FIXED'){
                            //     demand.money = item.lowPreAmount + " 元";
                            //     demand.demandDetail.prePrice = item.lowPreAmount + " 元";
                            // }else if(item.priceType == 'RANGE'){
                            demand.money = item.lowPreAmount + " - " + item.highPreAmount + " 元";
                            demand.demandDetail.prePrice = item.lowPreAmount + " - " + item.highPreAmount + " 元";
                            // }else{
                            //     demand.money = 0 + " 元";
                            //     demand.demandDetail.prePrice = 0 + " 元";
                            // }
                            demand.expectedDeliveryTime = item.expectedDeliveryTime;
                            demand.deadline = item.deadline;
                            demand.statusCn = item.statusCn;
                            this.tableData.push(demand);
                            console.log(this.tableData);
                        });
                    } else {
                        this.total = 0;
                    }
                });
            },
            // 审核查看
            toDialog(val, demand) {
                this.dialogVisible = true;
                // getUserInfo(demand.demandDetail.creator).then((res)=>{
                //     if(res){
                //         demand.demandDetail.username = res.name;
                this.demand = demand.demandDetail;
                this.currentAudit = val;
                if (val === 0) {
                    this.title = "审核详情";
                    this.auditForm = {};
                } else {
                    this.title = "查看详情";
                }
                // }
                // });

            },
            // 确定审核
            auditSubmit(uuid) {
                if (this.auditForm.status === undefined) {
                    this.$message.warning('请选择审核结果！');
                } else if (this.auditForm.status === 'REJECT' && this.auditForm.reason === undefined) {
                    this.$message.warning('请输入驳回原因！');
                } else {
                    this.auditForm.uuid = uuid;
                    auditDemand(this.auditForm).then((res) => {
                        if (res) {
                            this.$message.success('审核成功！');
                            this.dialogVisible = false;
                            this.search();
                        }
                    });
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;

        .orderManagementContent {
            background: #fff;

            .printOrderListBox {
                padding: 20px;

                .orderSearchBox {

                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-bottom: 22px;
                    }

                    .resetBtn {
                        color: #333333;
                        margin-bottom: 22px;
                    }
                }

                .tableContent {
                    min-height: 600px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }

        //审核查看详情中title的样式
        /deep/ .el-dialog__header {
            border-bottom: 1px solid #ddd;

            .el-dialog__title {
                color: #000;
                font-weight: 700;
                font-size: 16px;

            }
        }


        .dialogBox {
            .details {
                .detailsItem {
                    padding-bottom: 20px;

                    h3 {
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        // border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }

                    .itemContent {
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        // padding: 0 30px;
                        .one-row {
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            font-size: 14px;

                            .label {
                                padding-right: 15px;
                                min-width: 95px;
                                // font-size: 14px;
                                color: rgba(0, 0, 0, 0.85);
                            }

                            .name {
                                // color: #000;
                                // font-size: 14px;
                                color: rgba(0, 0, 0, 0.65);
                            }
                        }

                        /deep/ .nameimg img {
                            width: 100% !important;
                        }


                        .two-row {
                            // width: 100%;
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            font-size: 14px;

                            img {
                                width: 100%;
                            }

                            .label {
                                padding-right: 15px;
                                min-width: 95px;
                                color: rgba(0, 0, 0, 0.85);
                            }

                            .name {
                                // color: #000;
                                color: rgba(0, 0, 0, 0.65);

                                p {
                                    width: 650px;
                                }

                            }
                        }
                    }

                    .itemPictureContent {
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;

                        .one-row {
                            width: 30%;
                            margin-bottom: 22px;

                            img {
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }

                            .name {
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;

                                .label {
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }

            .audit {
                padding-bottom: 20px;

                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }

                .auditContent {
                    // padding: 0 30px;
                }

                .cause {
                    display: flex;
                    margin-top: 20px;

                    .causeTitle {
                        min-width: 80px;
                        color: #3a8ee6;
                    }

                    .causeContent {
                        color: #000;
                    }
                }

                .auditEnter {
                    text-align: center;
                    padding-top: 20px;

                    button {
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/auditManagement/designAudit/demandAudit.vue